<template>
<view>
  <view
    class="list"
    wx:for="{{list}}"
    wx:key="name"
    class="item {{list.length - 1 === index && !showFooterBtn ? 'no-border' : ''}}"
    wx:style="{{itemStyle}}"
  >
    <view class="item-header">
      <view class="item-name">{{item.name}}</view>
      <view>
        <text class="item-distance">{{item.distance_desc}}</text>
        <view wx:if="{{canGuide}}" class="item-guide" bindtap="toGuide(item)"><image class="icon-guide" src="https://ut-static.udache.com/webx/ut/V7wGh8vQW81jACg4d9Ngv.png" />导航</view>
      </view>
    </view>
    <view class="item-desc">{{item.detail_name}}</view>
    <view class="item-price" wx:style="{{priceLabelStyle}}">
      <view class="price-vip">
        <text class="label">优惠价格:</text>
        <text class="value" wx:style="{{priceStyle}}"><text class="unit">¥</text>{{item.vip_price}}</text>
      </view>
      <view class="price-original">
        <text class="label">油站价格:</text>
        <text class="value"><text class="unit">¥</text>{{item.original_price}}</text>
      </view>
    </view>
  </view>
</view>
</template>

<script>
import { createComponent } from '@mpxjs/core'
import { post, is, bridge, build, xenv, trackEvent } from '@didi/webx-js'

createComponent({
  name: 'gas-list',
  properties: {
    list: {
      type: Array,
      value: []
    },
    showFooterBtn: {
      type: Boolean,
      value: true,
    },
    styleConfig: {
      type: Object,
      value: {}
    }
  },
  data: {
  },
  computed: {
    canGuide() {
      return (__mpx_mode__ === 'web' && (is('passenger')) || is('weixin')) || __mpx_mode__ === 'wx'
    },
    priceLabelStyle() {
      return { color: this.styleConfig.labelColor }
    },
    priceStyle() {
      return { color: this.styleConfig.priceColor }
    },
    itemStyle() {
      return { borderColor: this.styleConfig.borderColor }
    },
  },
  methods: {
    toGuide(item) {
      this.triggerEvent('toGuide', item)
    }
  }
})
</script>

<style lang="stylus" scoped>
@font-face {
  font-family: 'UniSansHeavyItalicCAPS';
  src: url('https://img-hxy021.didistatic.com/static/utfe/do1_l1Sw5zCiLssbdzlZQI12');
}
.item
  padding 48rpx 0 52rpx 0
  border-bottom: 1px dashed #C63200;
  &.no-border
    border-bottom none
  .item-header
    display flex
    margin-bottom 10rpx
    .item-name
      flex 1
    .item-name, .item-distance
      height: 48rpx;
      font-family: PingFangSC-Regular;
      font-size: 34rpx;
      color: #1B1B1B;
      font-weight: 400;
    .item-distance, .item-guide
      display inline-block
    .item-guide
      font-family: PingFangSC-Regular;
      font-size: 26rpx;
      color: #000000;
      padding-left 18rpx
      .icon-guide
        position relative
        top 2rpx
        right 2rpx
        width 26rpx
        height 26rpx
  .item-desc
    width: 423rpx;
    height: 30rpx;
    font-family: PingFangSC-Regular;
    font-size: 22rpx;
    color: #4E4E4E;
    font-weight: 400;
  .item-price
    display flex
    align-items: baseline;
    margin-top 32rpx
    color: #B6631D;
    .label
      font-family: PingFangSC-Medium;
      font-weight: 500
      font-size: 22rpx;

    .price-vip > .value
      font-family: UniSansHeavyItalicCAPS;
      font-weight: 400
      font-size: 60rpx;
      color: #E02D18;
      letter-spacing: 0;
      line-height: 60rpx;
      position relative
      bottom -4rpx
      .unit
        padding-right 8rpx
        font-size: 40rpx;
    .price-original
      padding-left 23rpx
      .value
        font-family: PingFangSC-Medium;
        font-weight: 500
        font-size: 22rpx;
      .unit
        padding-right 6rpx
</style>

<script type="application/json" lang="json">
{
  "component": true,
  "usingComponents": {}
}
</script>
